<template>
<v-card>
  <v-card-title class="title cardTitle" v-if="title">{{title}}</v-card-title>
  <v-data-table dense :headers="headers" :items="items" hide-actions single-line class="elevation-0" :pagination.sync="pagination">
    <template slot="headers" slot-scope="props">
      <tr>
        <th v-for="header in props.headers" :key="header.text" @click="changeSort(header.value)" class="text-xs-left"  :class="colClass(header.column,{})">
          <v-icon v-if="pagination.sortBy!='' && pagination.sortBy==header.value" small>{{pagination.descending?'arrow_downward':'arrow_upward'}}</v-icon>
          <span>{{ header.text }}</span>
        </th>
      </tr>
    </template>
      <template slot="items" slot-scope="props">
          <tr :class="rowclassfunc(props.item)" class="{ rowSelected: props.item[primaryKeyName]==selectedKey }" @click="rowClicked($event,props.item)">
              <td v-if="props.item.editMode" colspan="100" style="background-color:inherit"><slot name="rowEdit" :value="props.item"></slot></td>
              <td v-if="favorites && !props.item.editMode" class="favoriteColumn pr-0 pl-0">
                <v-btn flat icon v-on:click.stop="favClicked(props.item)">
                  <v-icon v-if="isFavorite(props.item)" color="yellow darken-2">grade</v-icon>
                  <v-icon class="outlined" v-else color="grey lighten-3">grade</v-icon>
                </v-btn>
              </td>
            <!-- eslint-disable-next-line -->
            <td v-if="!(props.item && props.item.editMode)" v-for="col in columns" :key="col.field" :col="col" :class="colClass(col,props.item)">
              <slot v-if="!col.customSlot" name="cell" :column="col" :row="props.item" :value="formatValue(props.item[col.field],col.dataType,false,col.format)" >
                <v-icon v-if="col.checkbox" >{{cellData(col,props.item)}}</v-icon>
                <span v-else v-html="cellData(col,props.item)"></span>
              </slot>
              <slot v-if="col.customSlot" name="customCell" v-bind:col="col" v-bind:item="props.item">

              </slot>
            </td>
          </tr>
      </template>

    </v-data-table>
    <slot></slot>
    </v-card>
</template>

<script>
  import moment from 'moment';
  import numeral from 'numeral';
  import GatCommon from './GatCommon.js';
  export default {
    name: 'GatGrid',

    props:["items","columns","title","keyName","selectable","favorites","rowclass"],

    data: function(){
      return{
        selectedItem:{},
        pagination: {
          sortBy: '',
          rowsPerPage:-1,
        },
      }
    },

    //*** Computed properties/values ***
    computed:{


      //headers
      headers(){
        let result = [];
        if(this.columns){
          if(this.favorites){result.push({sortable:false,width:"10px"})}

          this.columns.map(column=>{
            let header = {};
            header.text = column.header;
            header.sortable = column.sortable;
            header.column = column;
            header.value = column.field;
            if(column.width){
              header.width = column.width;
            } else{
              // header.width ="1%"
            }
            // if(!(this.$vuetify.breakpoint.xsOnly && column.hideOnPhone)){
               result.push(header);
            // }

          });
        }
        return result;
      },

      //primaryKeyName
      primaryKeyName(){
        let result = this.keyName;
        if(!result){
          result = "ID";
        }
        return result;
      },

      //selectedKey
      selectedKey(){
        if(this.selectedItem && this.selectedItem.hasOwnProperty(this.primaryKeyName)){
          return this.selectedItem[this.primaryKeyName];
        } else{
          return -1;
        }
      },

    },

     //*** watchers  ****
    watch:{
      //items changed
      items:function(){
        this.selectedItem={};
      },
      //selectedItem changed
      selectedItem:function(newItem,oldItem){
        if(newItem != oldItem){
          this.$emit('item-changed', newItem);
        }
      }
    },

      //*** methods  ****
      methods:{

        //cellData
        cellData(column, rowItem){
            if(column.calculated){
              return column.calculated(rowItem);
            }
            if(column.linkUrl){
              let url = column.linkUrl.replace(' ','');
              return'<a class="gridLink" href="'+this.replaceFields(url,rowItem,true)+'">'+this.replaceFields(column.linkText,rowItem)+'</a>';
            }

            if(column.icon){
              return '<v-icon>'+rowItem[column.field]+'</v-icon>';
            }

            if(column.checkbox){
              if(rowItem[column.field]=='1'){
                return 'check_box';
              } else{
                return "check_box_outline_blank";
              }
            }




            return '<span style="white-space: pre-wrap;word-wrap: break-word;">'+this.formatValue(rowItem[column.field],column.dataType,false,column.format)+'</span>';

        },

        rowclassfunc(rowItem){
          let result="";
          if(typeof this.rowclass == 'string'){
            result = this.rowclass;
          } else if(typeof this.rowclass == 'function'){
            result = this.rowclass(rowItem);
          }
          return result;
        },

        //colClass
        colClass(col,rowItem){
          let result = "";

          if(col && col.calculatedClass){
            result = col.calculatedClass(rowItem);
          }

          if(this.$vuetify.breakpoint.xsOnly){
            result = result+ " pr-2 pl-1";
            if(col && col.hideOnPhone){
              result= result+" hidden-xs-only"
            }
          }
          else if(this.$vuetify.breakpoint.smOnly){
            result = result+ " pr-3 pl-2";
          }

          if(col && col.checkbox){
            result = result+" text-xs-center";
          }

          if(col && col.dataType == "number"){
            result = result+" text-xs-right";
          }

          return result;
       },

        //change sort
        changeSort(column) {
                if (this.pagination.sortBy === column) {
                  this.pagination.descending = !this.pagination.descending
                } else {
                  this.pagination.sortBy = column
                  this.pagination.descending = false
                }
              },

        isFavorite(rowItem){
          let keyName = this.keyField;
          if(!keyName){keyName = 'ID';}
          let idx = this.favorites.findIndex(item=>{return item.FAV_KEY==rowItem[keyName]});
          return idx >= 0;
        },

        favClicked(rowItem){
          this.$emit('favClick', rowItem);
        },

        formatValue(value,dataType,isUrl,colFormat){
          let result = ""+value;
          if(result=='null'){
            result = '';
          }
          if(isUrl){
            result = result.replace(/ /g,"");
          }

          if(dataType == "date"){
            if(value==null){
              result = '';
            } else{
              result = moment(value).format(GatCommon.datetimeDisplaySettings.dateFormat);
            }
          }

          if(dataType == "datetime"){
            if(value==null){
              result = '';
            } else{
              result = moment(value).format(GatCommon.datetimeDisplaySettings.datetimeFormat);
            }
          }

          if(dataType == "number"){
            if(value==null){
              result = '';
            } else if(colFormat){
              result = numeral(value).format(colFormat);
            }
          }

          return result;
        },

        replaceFields(text,item,isUrl){
          let result = text;
          if(text){
            let fieldSections = text.split('field[');
            for (let index = 1; index < fieldSections.length; index++) { //kun felt fra andre, pga split: 'Navn field[LASTNAME], field[FIRST].' => ['Navn ' , 'LASTNAME], ' , 'FIRST].']
              let str = fieldSections[index];
              if(str.includes(']')){
                let field = str.substring(0, str.indexOf(']'));
                result = result.replace('field['+field+']',this.formatValue(item[field],"string",isUrl));
              }
            }

          }

          return result;

        },

        rowClicked:function(event,rowItem){
           if(!event.target.href){
              if(this.selectable){
                 this.selectedItem = rowItem;
                }
              this.$emit('row-clicked', rowItem);
            }
        },

      },

    }
</script>

<style scoped>
    .rowSelected{
      background-color:lightblue;
    }

     .cardTitle{
        color:var(--gatGroupCaption);
     }
   .gridLink{
      color:var(--gatLinkColor);
    }


</style>

<style>
   .gridLink{
      text-decoration: none;
      color:var(--gatLinkColor);
    }

</style>

